// extracted by mini-css-extract-plugin
export var dividerLine = "_78-3";
export var itemImage = "_78-9";
export var lightDivider = "_78-4";
export var modalContent = "_78-5";
export var modalContentCompact = "_78-6";
export var productCard = "_78-a";
export var productImage = "_78-b";
export var productImageCompact = "_78-7";
export var productImagePlaceholder = "_78-c";
export var productImagePlaceholderCompact = "_78-8";
export var progressBarBackground = "_78-1";
export var progressBarContainer = "_78-0";
export var progressBarFill = "_78-2";